import { useQuery } from '@tanstack/react-query';
import { fetchUserSettings, fetchUserSettingsOptions } from '../api/userSettings';

const BASE_OPTIONS = {
  staleTime: 60_000,
  gcTime: 5 * 60_000,
};

export function useUserSettingsQuery(options = {}) {
  return useQuery({
    queryKey: ['userSettings'],
    queryFn: ({ signal }) => fetchUserSettings(signal),
    ...BASE_OPTIONS,
    ...options,
  });
}

export function useUserSettingsOptionsQuery(options = {}) {
  return useQuery({
    queryKey: ['userSettingsOptions'],
    queryFn: ({ signal }) => fetchUserSettingsOptions(signal),
    ...BASE_OPTIONS,
    ...options,
  });
}
